import { Component, Prop, Vue } from 'vue-property-decorator';
import Avatar from '@/components/common/avatar/Avatar.vue';
import { UserDTO } from '@/models/user';

type badgeProps = {
  badgeIcon: string;
  badgeColor: string;
};

@Component({
  components: {
    Avatar
  }
})
export default class UserInformation extends Vue {
  @Prop({ default: () => ({} as UserDTO) }) user: UserDTO;
  @Prop() pending: boolean;
  @Prop({ default: false }) isStatusShow: boolean;

  get badgeIconProps(): badgeProps {
    if (!this.isStatusShow) {
      return {
        badgeColor: '',
        badgeIcon: ''
      };
    }
    if (this.pending === false) {
      return {
        badgeIcon: 'mdi-check-circle',
        badgeColor: 'success'
      };
    }
    return {
      badgeIcon: 'mdi-clock',
      badgeColor: 'warning'
    };
  }
}
